import { useTranslation } from "react-i18next";
import { AlertTriangle } from "@untitledui/icons";
import { usePerformanceMode } from "@/lib/performanceMode";
import { formatLogInstant } from "@/lib/format";

/**
 * Upozornění na běžící režim Performance.
 *
 * Patří tam, kde by jeho existence jinak vypadala jako vada — hlavně do prohlížeče
 * komunikačních logů, kde by jinak někdo hledal řádky, které nikdy nevznikly.
 * Nevykresluje nic, dokud režim neběží.
 *
 * <b>Uvádí i okamžik zapnutí</b>, a to schválně. Zápis do logu je asynchronní, takže
 * řádky vzniklé těsně před přepnutím se v prohlížeči objeví až po něm — a bez času
 * zapnutí to vypadá, jako by režim vůbec nefungoval. Rozdíl přitom můžou být sekundy.
 */
export function PerformanceModeBanner({ messageKey = "perfMode.logsBanner" }: { messageKey?: string }) {
  const { t } = useTranslation();
  const { data } = usePerformanceMode();

  if (!data?.active) {
    return null;
  }

  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-lg bg-warning-primary p-3 text-sm text-warning-primary ring-1 ring-warning"
    >
      <AlertTriangle className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <span>
        {t(messageKey, { level: t(`perfMode.level.${data.level}`) })}{" "}
        {t("perfMode.sinceHint", { since: formatLogInstant(data.startedAtEpochMs) })}
      </span>
    </div>
  );
}
